import React from 'react';
import { Button } from '@/components/ui/button';
import {
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog';
import { useHistory } from 'react-router-dom';
import routeConfig from '../../config/routeConfig';
import digsignature from '../../images/dig_signature.jpeg';

const ProductSign = () => {
	const history = useHistory();

	return (
		<div style={{ padding: 24, maxHeight: '90vh', overflow: 'auto' }}>
			<DialogHeader>
				<DialogTitle>Firma Electrónica</DialogTitle>
			</DialogHeader>
			<DialogDescription>
				<strong>
					¿Te gustaría firmar tus documentos sin necesidad de un
					lápiz?
				</strong>
				<br />
				<strong>
					¿Sientes el riesgo de que tu firma sea falsificada en
					documentos importantes?
				</strong>
				<br />
				<strong>¿Sabes lo que es una firma electrónica?</strong>
				<br />
				<strong>Pues aquí te lo explicamos.</strong>
				<br />
				<br />
				Una firma electrónica es un conjunto de autenticaciones
				digitales asociadas a un documento específico. Esto permite
				identificar al firmante de manera irrefutable, se mantiene la
				integridad del documento firmado y asegurda el no repudio del
				documento firmado
				<br />
				<br />
				Nuestro servicio de firma electrónica se caracteriza por ofrecer
				un servicio rápido y completamente automatizado a menor precio.
			</DialogDescription>
			<img src={digsignature} alt="" style={{ width: '100%' }} />
			<p>Inicia sesión y sube un documento para verlo por tí mismo.</p>
			<Button
				style={{ width: 'auto' }}
				variant="default"
				onClick={() => history.push(routeConfig.signDocument)}
			>
				Continuar
			</Button>
		</div>
	);
};

export default ProductSign;
